import React from "react";
import { Link, useLocation } from "react-router-dom";

export function NavItem({ icon, title, to, className, badge }) {

    const location = useLocation();

    if(location.pathname === to) {

    }

    const hasBadge = typeof badge === "number" && badge > 0;

    return (
        <>
            <Link className={`relative btn btn-ghost flex flex-row items-center ${location.pathname === to && "border-2 border-current hover:border-current"} ${className ?? ""} `} to={to} data-tip={title}>
                {icon}
                {hasBadge && (
                    <span className="badge badge-error badge-sm text-white font-bold absolute -top-1 -right-1 h-5 min-w-[1.25rem] px-1">
                        {badge > 99 ? "99+" : badge}
                    </span>
                )}
                <p className="block md:hidden min-w-12 text-start">{title}</p>
            </Link>
        </>
    )
}
